module.exports = __webpack_public_path__ + "static/media/5loyalty-black.5108bb2e.svg";